import { useTranslation } from 'react-i18next'
import { FieldArray, useFormikContext } from 'formik'

import { EMPTY_LIST, NOTIFICATION_TYPE } from '../../../../constants/common'
import Button from '../../../Button'
import { NotificationInline } from '../../../Notification'
import {
  CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES,
  QA_NAME_ADD_PARAMETER_BUTTON,
} from '../ConnectedRequestsMassEditModal.constants'
import {
  createEmptyParameter,
  getCanAddParameter,
} from '../ConnectedRequestsMassEditModal.utils'

import { getParameterRowKey } from './ConnectedRequestsMassEditModalFields.utils'
import { ParameterRow } from './ParameterRow'

import * as styles from '../ConnectedRequestsMassEditModal.module.css'

import PlusIcon from '../../../../icons/plus.svg'

function ConnectedRequestsMassEditModalFields({
  requestId,
  onOpenConnectedRequestsPreview,
}) {
  const { t } = useTranslation()
  const { values } = useFormikContext()

  const parameters =
    values[CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES.parameters] ||
    EMPTY_LIST
  const canAddParameter = getCanAddParameter(parameters)

  function handleOpenPreview() {
    onOpenConnectedRequestsPreview?.(values)
  }

  return (
    <FieldArray name={CONNECTED_REQUESTS_MASS_EDIT_FORM_FIELD_NAMES.parameters}>
      {({ push, remove }) => {
        function handleAddParameter() {
          if (canAddParameter) {
            push(createEmptyParameter())
          }
        }

        return (
          <>
            <div className={styles.infoText}>
              <NotificationInline
                actions={[
                  {
                    callback: handleOpenPreview,
                    text: t(
                      'ConnectedRequestsMassEdit.ViewAllAttachedRequestsKey'
                    ),
                  },
                ]}
                className={styles.notification}
                text={t('ConnectedRequestsMassEdit.AttentionMessageKey')}
                type={NOTIFICATION_TYPE.info}
              />
            </div>
            {parameters.map((parameter, index) => {
              return (
                <ParameterRow
                  index={index}
                  key={getParameterRowKey({ index, parameter })}
                  parameter={parameter}
                  parameters={parameters}
                  requestId={requestId}
                  onRemoveParameter={remove}
                />
              )
            })}
            <Button.Text
              beforeIconProps={{ Icon: PlusIcon }}
              className={styles.addButton}
              disabled={!canAddParameter}
              qaName={QA_NAME_ADD_PARAMETER_BUTTON}
              text={t('ConnectedRequestsMassEdit.AddParameterButtonKey')}
              onClick={handleAddParameter}
            />
          </>
        )
      }}
    </FieldArray>
  )
}

export default ConnectedRequestsMassEditModalFields
